import { render, staticRenderFns } from "./App_form_2.vue?vue&type=template&id=c84617fe&"
import script from "./App_form_2.vue?vue&type=script&lang=js&"
export * from "./App_form_2.vue?vue&type=script&lang=js&"
import style0 from "./App_form_2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports